export default {"src":"/_next/static/media/instagram.97804b0f.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};